"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfFacilityVerificationDto = instanceOfFacilityVerificationDto;
exports.FacilityVerificationDtoFromJSON = FacilityVerificationDtoFromJSON;
exports.FacilityVerificationDtoFromJSONTyped = FacilityVerificationDtoFromJSONTyped;
exports.FacilityVerificationDtoToJSON = FacilityVerificationDtoToJSON;
exports.FacilityVerificationDtoToJSONTyped = FacilityVerificationDtoToJSONTyped;
const AddressDto_1 = require("./AddressDto");
/**
 * Check if a given object implements the FacilityVerificationDto interface.
 */
function instanceOfFacilityVerificationDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('address' in value) || value['address'] === undefined)
        return false;
    if (!('isVerified' in value) || value['isVerified'] === undefined)
        return false;
    if (!('orientationDocuments' in value) || value['orientationDocuments'] === undefined)
        return false;
    if (!('hasExpressedInterest' in value) || value['hasExpressedInterest'] === undefined)
        return false;
    return true;
}
function FacilityVerificationDtoFromJSON(json) {
    return FacilityVerificationDtoFromJSONTyped(json, false);
}
function FacilityVerificationDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'name': json['name'],
        'address': (0, AddressDto_1.AddressDtoFromJSON)(json['address']),
        'isVerified': json['isVerified'],
        'orientationDocuments': json['orientationDocuments'] == null ? null : json['orientationDocuments'],
        'hasExpressedInterest': json['hasExpressedInterest'],
    };
}
function FacilityVerificationDtoToJSON(json) {
    return FacilityVerificationDtoToJSONTyped(json, false);
}
function FacilityVerificationDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'name': value['name'],
        'address': (0, AddressDto_1.AddressDtoToJSON)(value['address']),
        'isVerified': value['isVerified'],
        'orientationDocuments': value['orientationDocuments'],
        'hasExpressedInterest': value['hasExpressedInterest'],
    };
}
//# sourceMappingURL=FacilityVerificationDto.js.map